const messages = {
    LTV_EXPLAIN: "LTV é uma métrica de vendas que calcula o lucro total gerado por um cliente enquanto ele continua comprando seus produtos e/ou serviços.",
    LTV_PERIOD: "LTV calculado com base nos últimos 12 meses.",
    LOADING: "Carregando...",
    NO_DATA: "Sem dados.",
    NO_DATA_PERIOD: "Sem dados no período selecionado.",
};

const __e = (key) => {
    return messages[key] || key;
};


export { __e };